<script lang="ts">
/**
 * @fileoverview CSS のメディアクエリ状況を JS 側で拾えるようにするためのオブザーバー
 * @description JS と CSS と両者でウインドウサイズでのスタイル切り替え（ブレークポイントの管理）を避けるため、CSS 側のブレークポイント状況を JS に伝えて、JS 側は CSS から伝えられた情報を元にスタイル管理する
 */
import { defineComponent, ref, nextTick, onBeforeUnmount } from 'vue'
import throttle from 'lodash/throttle'
import { useMediaQueryStore } from '@/stores/mediaQuery'

export default defineComponent({
  name: 'MediaQueryObserver',

  setup() {
    // constants
    const STATE_CLASS_NAME = {
      sp: 'is-sp',
      phablet: 'is-phablet',
      tablet: 'is-tablet',
    }

    // store
    const mediaQueryStore = useMediaQueryStore()

    // data
    const mediaQueryIndicator = ref()

    // window のリサイズイベントを監視して、幅に変更があったらメディアクエリの状況を再取得する
    const resizeListener = throttle(async () => {
      mediaQueryStore.setContext()
    }, 100)

    nextTick(() => {
      mediaQueryStore.init(mediaQueryIndicator.value, STATE_CLASS_NAME)
      mediaQueryStore.setContext()
    })

    window.addEventListener('load', mediaQueryStore.setContext)
    window.addEventListener('resize', resizeListener)

    onBeforeUnmount(() => {
      // イベントリスナー解除
      window.removeEventListener('load', mediaQueryStore.setContext)
      window.removeEventListener('resize', resizeListener)
    })

    return {
      // constants
      STATE_CLASS_NAME,

      // store
      mediaQueryStore,

      // data
      mediaQueryIndicator,
    }
  }
})
</script>

<template>
  <div
    ref="mediaQueryIndicator"
    class="o-list__mediaQueryIndicator">
    <ul class="o-list__mediaQueryIndicator--items">
      <li
        :class="[
          'o-list__mediaQueryIndicator--item',
          STATE_CLASS_NAME.sp,
        ]">
        &nbsp;
      </li>
      <li
        :class="[
          'o-list__mediaQueryIndicator--item',
          STATE_CLASS_NAME.phablet,
        ]">
        &nbsp;
      </li>
      <li
        :class="[
          'o-list__mediaQueryIndicator--item',
          STATE_CLASS_NAME.tablet,
        ]">
        &nbsp;
      </li>
    </ul>
  <!-- /.o-list__mediaQueryIndicator --></div>
</template>

<style lang="sass" scoped>
.o-list__mediaQueryIndicator
  $root: &
  width: 100%
  position: fixed
  top: 0
  left: 0

  & &--items
    display: flex

  & &--item
    width: 0
    height: 0
    display: none
    overflow: hidden

  +breakpoint($max-media: sp)
    #{$root}--item
      &.is-sp
        display: block

  +breakpoint($max-media: phablet)
    #{$root}--item
      &.is-phablet
        display: block

  +breakpoint($max-media: tablet)
    #{$root}--item
      &.is-tablet
        display: block
</style>
